import * as XLSX from "@e965/xlsx";

const INVALID_SHEET_NAME_CHARS = /[:\\/?*[\]]/g;

export function downloadCategoriesXlsxFile(params: {
  filename: string;
  sheetName: string;
  rows: (string | number)[][];
}) {
  const { filename, sheetName, rows } = params;
  const safeSheet = sheetName.replace(INVALID_SHEET_NAME_CHARS, " ").trim().slice(0, 31);
  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, safeSheet || "Categories");
  const name = filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`;
  XLSX.writeFile(wb, name);
}
